import { Suspense, type ReactNode } from 'react';
import { Link as RouterLink, useLocation } from 'react-router-dom';

import GlobalComponents from 'components/GlobalComponents';
import LeftHandLayout, {
	type LeftHandLayoutProviderProps,
} from 'components/LeftHandLayout';
import Errors from 'components/legacy/Errors';
import SuspenseFallback from './SuspenseFallback';

interface PageShellProps {
	roles?: LeftHandLayoutProviderProps['roles'];
	children: ReactNode;
}

const PageShell = ({ roles: layoutRoles, children }: PageShellProps) => {
	const { pathname } = useLocation();

	return (
		<>
			<LeftHandLayout
				appPath={pathname}
				linkComponent={RouterLink}
				linkProp="to"
				roles={layoutRoles}
				sx={{
					minHeight: '100vh',
					minWidth: '100vw',
					maxWidth: '100vw',
				}}
			>
				<Suspense fallback={<SuspenseFallback />}>{children}</Suspense>
			</LeftHandLayout>
			<Errors />
			<GlobalComponents />
		</>
	);
};

export default PageShell;
